<dx-box
    #userDashboardWidgetBox
    width="100%"
    height="100%"
    direction="col"
    class="user-dashboard-widget-container"
    [elementAttr]="{ id: 'userDashboardWidgetBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-toolbar width="100%">
                <dxi-item location="before" [visible]="!!userList && !!userList.length">
                    <div *dxTemplate [ngClass]="{ 'width-120px': widgetWidth < 480 }">
                        <ng-container *ngIf="widgetWidth >= 480">
                            <app-multi-column-selector
                                #userSelector
                                [name]="'User View'"
                                [gridSource]="userList"
                                [boxValue]="userGridBoxValue"
                                [valueExpr]="'userId'"
                                [displayExpr]="'name'"
                                [columnDef]="userColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [placeholder]="'Select User...'"
                                (gridSelectionEvent)="onUserSelection($event)"
                            ></app-multi-column-selector>
                        </ng-container>
                        <ng-container *ngIf="widgetWidth < 480">
                            <app-multi-column-selector
                                #userSelector
                                cssClass="widget-drop-down-box"
                                [name]="'User View'"
                                [gridSource]="userList"
                                [boxValue]="userGridBoxValue"
                                [valueExpr]="'userId'"
                                [displayExpr]="'name'"
                                [columnDef]="userColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [placeholder]="'Select User...'"
                                (gridSelectionEvent)="onUserSelection($event)"
                            ></app-multi-column-selector>
                        </ng-container>
                    </div>
                </dxi-item>
                <dxi-item [location]="widgetWidth >= 360 ? 'before' : 'after'">
                    <div *dxTemplate>
                        <dx-select-box
                            [width]="100"
                            [dataSource]="chartTypes"
                            [(value)]="selectedChartType"
                            (onSelectionChanged)="onChartTypeChange()"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item location="before" [visible]="false">
                    <div *dxTemplate>
                        <dx-select-box
                            [width]="100"
                            displayExpr="text"
                            [dataSource]="viewOptions"
                            [(value)]="selectedViewOption"
                            (onSelectionChanged)="onViewOptionChange()"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <ng-container *ngIf="widgetWidth >= 360">
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Refresh"
                                hint="Refresh"
                                icon="refresh"
                                [width]="90"
                                (onClick)="onRefreshClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </ng-container>
            </dx-toolbar>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto" *ngIf="widgetWidth < 360">
        <dx-toolbar width="100%">
            <dxi-item location="before">
                <div *dxTemplate class="margin-top-10px">
                    <dx-button
                        type="default"
                        text="Refresh"
                        hint="Refresh"
                        icon="refresh"
                        [width]="90"
                        (onClick)="onRefreshClick()"
                    ></dx-button>
                </div>
            </dxi-item>
        </dx-toolbar>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate class="chart-container">
            <app-user-dashboard-bar-chart
                *ngIf="!!dashboardData && loadingCompleted"
                [selectedUser]="selectedUser"
                [selectedViewOption]="selectedViewOption"
                [palette]="currentPaletteName"
                [paletteMode]="currentPaletteMode"
                [chartData]="dashboardData"
                [widgetMode]="true"
                [chartType]="selectedChartType"
                [width]="chartWidth"
                [height]="chartHeight"
            ></app-user-dashboard-bar-chart>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    *ngIf="!loadingCompleted || loadingVisible"
    [position]="{ of: !widgetId ? 'body' : '#userDashboardWidgetBox' + widgetId }"
    [visible]="!loadingCompleted || loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
